import { LOCALE_UZ, LOCALE_RU } from '../constants';

const URL_LOCALES = [LOCALE_UZ, LOCALE_RU];

export const isUrlLocale = (segment) => URL_LOCALES.includes(segment);

export const stripLangPrefix = (path) => {
  const segments = path.split('/');
  if (segments.length > 1 && isUrlLocale(segments[1])) {
    return '/' + segments.slice(2).join('/') || '/';
  }
  return path;
};

export const buildLocalePath = (lang, path) => {
  const stripped = stripLangPrefix(path);
  return `/${lang}${stripped === '/' ? '' : stripped}`;
};
